import { io } from 'socket.io-client';
import { CHAT_IP } from './UseFunction';

// export const SOCKET = io(CHAT_IP);
export const SOCKET = null;
